"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAreaDrop = void 0;

var React = __importStar(require("react"));

var utils_1 = require("@bdl-cmn-shared-packages-npm/utils");

var use_mounted_state_1 = require("./use-mounted-state");

var createProcess = function createProcess(options, mounted) {
  return function (dataTransfer, event) {
    var uri = !!dataTransfer ? dataTransfer.getData('text/uri-list') : '';

    if (uri.length > 0) {
      (options.onUri || utils_1.noop)(uri, event);
    } else if (!!dataTransfer && !!dataTransfer.files && dataTransfer.files.length > 0) {
      (options.onFiles || utils_1.noop)(Array.from(dataTransfer.files), event);
    } else if (!!dataTransfer && !!dataTransfer.items && dataTransfer.items.length > 0) {
      dataTransfer.items[0].getAsString(function (text) {
        if (mounted) {
          (options.onText || utils_1.noop)(text, event);
        }
      });
    }
  };
};

var createBond = function createBond(process, setOver) {
  return {
    onDragOver: function onDragOver(event) {
      event.preventDefault();
    },
    onDragEnter: function onDragEnter(event) {
      event.preventDefault();
      setOver(true);
    },
    onDragLeave: function onDragLeave() {
      setOver(false);
    },
    onDrop: function onDrop(event) {
      event.preventDefault();
      event.persist();
      setOver(false);
      process(event.dataTransfer, event);
    },
    onPaste: function onPaste(event) {
      event.persist();
      process(event.clipboardData, event);
    }
  };
};

function useAreaDrop(options) {
  if (options === void 0) {
    options = {};
  }

  var onFiles = options.onFiles,
      onText = options.onText,
      onUri = options.onUri;
  var isMounted = use_mounted_state_1.useMountedState();

  var _a = React.useState(false),
      over = _a[0],
      setOver = _a[1];

  var process = React.useMemo(function () {
    return createProcess(options, isMounted());
  }, [onFiles, onText, onUri]);
  var bond = React.useMemo(function () {
    return createBond(process, setOver);
  }, [process, setOver]);
  return [bond, {
    over: over
  }];
}

exports.useAreaDrop = useAreaDrop;